import request from '@/axios/http'

const BASE = '/stage-api/pre/audition'

export function getCurrentPeriod (preType) {
	return request({
		url: `${BASE}/period/current`,
		method: 'get',
		params: preType ? { preType } : {}
	})
}

export function getLatestPeriod (preType) {
	return request({
		url: `${BASE}/period/latest`,
		method: 'get',
		params: { preType }
	})
}

export function listCurrentPeriods () {
	return request({
		url: `${BASE}/period/current/list`,
		method: 'get'
	})
}

export function listEntry (params) {
	return request({
		url: `${BASE}/entry/list`,
		method: 'get',
		params
	})
}

export function getEntryDetail (id) {
	return request({
		url: `${BASE}/entry/${id}`,
		method: 'get'
	})
}

export function submitEntry (data) {
	return request({
		url: `${BASE}/entry/submit`,
		method: 'post',
		data
	})
}

export function followIntent (entryId) {
	return request({
		url: `${BASE}/follow-intent`,
		method: 'post',
		params: { entryId }
	})
}

export function cancelFollowIntent (entryId) {
	return request({
		url: `${BASE}/follow-intent/cancel`,
		method: 'post',
		params: { entryId }
	})
}

export function getResult (periodId) {
	return request({
		url: `${BASE}/result/${periodId}`,
		method: 'get'
	})
}

export function getChampionTopic (limit = 10) {
	return request({
		url: `${BASE}/champion/topic`,
		method: 'get',
		params: { limit }
	})
}

export function downloadEntry (id) {
	return request({
		url: `${BASE}/entry/${id}/download`,
		method: 'get',
		responseType: 'blob',
		timeout: -1
	})
}
